import {ChangeDetectorRef, HostBinding,Component,ViewEncapsulation, OnInit, OnDestroy,SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import {HomeService} from '../../services/home.service';
import { Router,ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {MessageService} from '../../message.service';
import {AppSettings} from '../../settings';
import {BaseComponent} from '../base/base.component';
import {IRule} from '../../irule';

import{ArticleService} from '../../services/article.service';

declare var $:any;//Required for jquery use

@Component({
  selector: 'app-manage-article-type',
  templateUrl: './manage-article-type.component.html',
  styleUrls: ['./manage-article-type.component.css'],
  encapsulation:ViewEncapsulation.None
})
export class ManageArticleTypeComponent implements OnInit ,IRule {
  
  deltypeid:number=0;

	userName='';
  
  navigationsType=[];

	url:any=AppSettings.API_ENDPOINT;

	type_articles:any=[];

	msg:any;

	toastr:any;

	_router:any;

	record_empty:number =0;

    record_offset:number = 0;
	

	token:any='';

  	articleTypeList = [];

  	searchTxt:string = '';

  	per_page:number=10;
  	typeId:number = 0;
  	typeAddTxt:string = '';
  	typeOldTxt:string = '';
    typeInputLabel:string = 'Add New';
  
    loader_image:boolean =true

    notification:any=[];
  
 	@HostBinding('style.width') public width: string = '100%'; //for edge browser design issue

  constructor(msg:MessageService, toastr: ToastrService, _router: Router,private articleService:ArticleService) {
  	this.msg = msg;
    this.toastr = toastr;
    this._router =_router;

  }

  ngOnInit() {
  	try{

      let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

      if(!tokenA) throw 'Error in parse';

      if(!JSON.parse(tokenA)) throw 'Error in json parse';

      tokenA = JSON.parse(tokenA);


      this.token = tokenA.token;


      let data={
        token:tokenA.token,
        limit:this.per_page,
        'page':'settings'
      }
      this.loader_image =true

      this.typeList(data);


    }catch(error){

      this._router.navigate(['/login']);

    }
  }

  typeLazyList(offset)
  {
    
    let data={
      token:this.token,
      search:this.searchTxt,
      limit:this.per_page,
      offset:offset,
      'page':'settings'
    }
   
  this.loader_image =true
  this.record_empty =1;
  this.typeList(data);

  }

  ngAfterViewInit(){

  	//for lazy load
  	$(window).on("scroll", function() {  


      if(this._router.url == '/settings/manage-article-type'){


        if ($(window).scrollTop() + $(window).height() > $(document).height() - 100) {       


           if(this.record_empty == 0){

              this.record_offset+=this.per_page;

             

              this.typeLazyList(this.record_offset);

            }          

        }

      }


    }.bind(this));

  	$(document).ready(function(){

  		/* for search field placeholder */

  		$('input').blur(function(event) {
            var inputValue = this.value;
            if (inputValue) {
                this.classList.add('value-exists');
            } else {
                this.classList.remove('value-exists');
            }
        });

        /* for search field placeholder */
        $('a.tooltip-custom').click(function(){
        		$('.approver-popup > input ').addClass('value-exists');
        });
        /* for tooltip on icon */

        $('body').on('click','.tooltip-custom',function(){
         	$(this).tooltip("hide");
       	 });


	       let tl:any= $('body');
	         tl.tooltip({
	          trigger: "hover" ,
	          selector: '.tooltip-custom'
	      });

	      tl.on('show.bs.tooltip', () => {
	        //$('.tooltip-custom').not(this).remove();
	      });

	      /* for tooltip on icon */

	      //scrolltotop
	      $(window).scroll(function(){
				if ($(this).scrollTop() > 1) {
					$('#yt-totop').css({bottom:"25px"});
				} else {
				$('#yt-totop').css({bottom:"-50px"});
				}
			});
			
			$('#yt-totop').click(function(){
				$('html, body').animate({scrollTop: '0px'}, 800);
					return false;
			});

  	}.bind(this));
  }



 createTypeList(data){


  this.articleService.getCategoryType(data).subscribe( (res)=>{


      if(res.status=='success'){
       
        this.loader_image =false
         
        this.record_offset=0;

        this.articleTypeList = [];

        this.typeLazyList(this.record_offset);
        
 

      }else{        
        this.toastr.error(res.message, '', {timeOut: 5000});
      }
  });



 }



  typeList(data)
  {
  		this.articleService.getCategoryType(data).subscribe( (res)=>{

  	

        if(res.status=='success'){
         
          this.loader_image =false

          if(res.type !=undefined ){

            this.record_empty = 0;

          } else{

           this.record_empty =1;

          }

          if(this.articleTypeList.length==0 && this.record_offset!=0){
             
            this.articleTypeList=res.type;  
            

          } else if(res.type !=undefined  && this.record_offset!=0){


            res.type.forEach(element => {

              this.articleTypeList.push(element);
              
            });

          }else if(this.record_offset==0 && this.articleTypeList.length==0 ){

            this.articleTypeList=res.type;  

          }


          this.userName=res.user.name;

          this.navigationsType=res.navigation;

          this.notification =res.notification;
            
          this.broadcast_menu();
        	
        }else{        
          this.toastr.error(res.message, '', {timeOut: 5000});
        }
    });

  }


  searchArticleType()
  {
  	let data={
        token:this.token,
        search:this.searchTxt,
        limit:this.per_page,
        'page':'settings'
      }
     
    this.loader_image =true
    this.articleTypeList=[];
    this.record_offset=0;
    this.typeList(data);
     

  }

  delTypeList(typeid:number){

    this.deltypeid = typeid;

    
    $('#success-popup').modal('show');


  }

  deleteCategoryType(){

    let data={
      token:this.token,
      reqData:{
        id:this.deltypeid, 
        archive:true,
        'page':'settings'
      }
     
      //offset:this.record_offset
    }


    this.articleService.removeType(data).subscribe( (res)=>{
            

      if(res.status=='success'){

        let catI = this.articleTypeList.findIndex( (elm) => { return  elm.id ==  this.deltypeid});
          
        this.articleTypeList.splice(catI,1);

        this.deltypeid =0;


      }else{
        this.deltypeid =0;
      }

    });



  }

  addArticleType()
  {
    let msg = "";
    
    this.record_offset =0;

  	if (this.typeAddTxt.trim() != '' && (this.typeOldTxt.trim() != this.typeAddTxt.trim())) {
	  	let data={
	        token:this.token,
	        name:this.typeAddTxt,
           'page':'settings'
	      	//offset:this.record_offset
        }
        
	    msg =  'Type added successfully';
	    if(this.typeId > 0 && this.typeInputLabel == 'Edit')
	  	{
	  		data = Object.assign(data, {'id' : this.typeId,});
        msg = 'Type updated successfully';
        
        let catI = this.articleTypeList.findIndex( (elm) => { return  elm.id == this.typeId});
          
        this.articleTypeList[catI].value= this.typeAddTxt;
	  	} 

	    this.loader_image =true
      this.createTypeList(data);
      
	    this.typeAddTxt = '';
	    this.typeInputLabel = 'Add New';  
	    //this.typeId = 0; 
	    this.toastr.success(msg, '', {timeOut: 5000});

	    //hide the popup after successfull addition
	    $('#create_article_type_popup').modal('hide');
	}
	else {
		msg = 'Field can not be blank / same !';
		this.toastr.error(msg, '', {timeOut: 5000});
	}   

  }

  editTypeList(id:number,val:string)
  {
  	this.typeAddTxt = val;
    this.typeOldTxt = val;
    this.typeId = id;
    this.typeInputLabel = 'Edit'; 

    //show the popup after successfull addition
	$('#create_article_type_popup').modal('show');
  }

  broadcast_menu(){
    
    this.msg.sendMessage({'user':this.userName,'notification':this.notification,'type':'left_menu_link','navigations':this.navigationsType});
   }  

}
